// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"829f7a52","378":"d9b226b6","652":"f7d01f53"}[chunkId] + ".chunk.js";
};